import React, {useState, useEffect} from 'react';
import {
    Page,
    Card,
    SkeletonBodyText
  } from '@shopify/polaris';

import Common from './Common'
import Product from '../../types/product';
import { productService } from '../../services/product';


function EditProductGroup(props: any){
    const { match: { params } } = props;
    const [isLoading, setIsLoading] = useState(true);
    const [ignoreParentVariants, setIgnoreParentVariants] = useState(false);
    const [selectedParentProduct, setSelectedParentProduct] = useState<Product | null>(null);
    const [selectedChildrenProducts, setSelectedChildrenProducts] = useState<Product[] | null>(null);

    useEffect(() => {
        productService.singleGroup(params.handle).then(data => {
            setIgnoreParentVariants(data.ignore_parent);
            setSelectedParentProduct(data.parent);
            setSelectedChildrenProducts(data.children);
            setIsLoading(false);
        });
    }, [params.handle]);

    const updateProductGroup = (orderChanged: boolean, childrenProductsSelectionChanged: boolean, ignoreParentVariantsChecked: boolean) => {
        if( selectedParentProduct && selectedChildrenProducts ) {
            const reqBody = {
                parent_handle: selectedParentProduct.handle,
                parent_id: selectedParentProduct.id,
                children: selectedChildrenProducts.map((item) => {
                    return {id: item.id, handle: item.handle};
                }),
                order_changed: orderChanged,
                ignore_parent: ignoreParentVariantsChecked,
                children_selection_changed: childrenProductsSelectionChanged
            }
            // update request
            productService.updateGroup(reqBody).then(data => {
                if( data )
                props.history.push('/');
            });
        }
    }

    return isLoading ? (<Page><Card sectioned><SkeletonBodyText lines={3} /></Card></Page>) : (
        <Common
            selectedParentProduct={selectedParentProduct}
            selectedChildrenProducts={selectedChildrenProducts}
            handleParentProductChange={setSelectedParentProduct}
            handleChildrenProductsChange={setSelectedChildrenProducts}
            ignoreParent={ignoreParentVariants}
            onSave={updateProductGroup}
        />
    );
}

export default EditProductGroup;